import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getBookCitationInfo } from "../../api";

function BookViewer() {
    const { book_name, chapter_name } = useParams();
    const [pdfBookImages, setPdfBookImages] = useState<string[]>();
    const [bookError, setBookError] = useState<string | null>(null);
    const [contentWidth, setContentWidth] = useState<number>(40); // Default: 40%
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const MIN_WIDTH = 30; // 30%
    const MAX_WIDTH = 100; // 100%
    const STEP = 10; // 10% per click

    async function fetchBookInfo() {
        setIsLoading(true);
        try {
            const bookFileData = await getBookCitationInfo(book_name, chapter_name);
            const bookChapterData = await bookFileData.data;
            if (bookChapterData.status === "success" && bookChapterData?.page_images) {
                setPdfBookImages(bookChapterData.page_images);
            } else if (bookChapterData.status === "error") {
                setBookError(bookChapterData?.message);
            }
        } catch (error: any) {
            console.error(`Failed to fetch source info `, error);
            setBookError(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        fetchBookInfo();
    }, []);
    return (
        <div className="flex flex-col h-full">
            <div className="p-3 flex items-center justify-between  ">
                <div className="flex justify-center w-full">
                    <p className="    justify-center text-2xl text-center px-4 text-ellipsis overflow-hidden whitespace-nowrap ">
                        {book_name} - {chapter_name}
                    </p>
                </div>
                <div className="flex items-center space-x-2">
                    <button
                        className="px-2 py-1 border border-gray-500 rounded bg-transparent hover:border-gray-400 disabled:hover:border-gray-400"
                        onClick={() => setContentWidth(w => Math.min(w + STEP, MAX_WIDTH))}
                        aria-label="Zoom In"
                        disabled={contentWidth + STEP > MAX_WIDTH}
                    >
                        +
                    </button>
                    <span className="text-sm text-black" style={{ display: "inline-block", width: "4ch", textAlign: "center" }}>
                        {contentWidth}%
                    </span>
                    <button
                        className="px-2 py-1 border border-gray-500 rounded bg-transparent hover:border-gray-400 disabled:hover:border-gray-400"
                        onClick={() => setContentWidth(w => Math.max(w - STEP, MIN_WIDTH))}
                        aria-label="Zoom Out"
                        disabled={contentWidth - STEP < MIN_WIDTH}
                    >
                        –
                    </button>
                </div>
            </div>
            <div
                className="flex-1 overflow-auto px-4 flex justify-center mb-4" // removed items-center
            >
                <div
                    style={{ width: `${contentWidth}%`, transition: "width 0.2s" }}
                >
                     {isLoading ? (
                        <div className="flex h-full justify-center items-center">
                            <div className="w-12 h-12 border-4 border-green-800 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    ) : bookError ? (
                        <div className="flex h-full justify-center items-center text-2xl">{bookError}</div>
                    ) : (
                        pdfBookImages &&
                        pdfBookImages.length > 0 &&
                        pdfBookImages.map((base64String, index) => (
                            <img
                                key={index}
                                src={`data:image/png;base64,${base64String}`}
                                alt={`Book page ${index + 1}`}
                                className="w-full h-auto mb-4"
                            />
                        ))
                    )}
                    {/* {bookError ? (
                        <div className="flex h-full justify-center items-center text-2xl">{bookError}</div>
                    ) : (
                        pdfBookImages &&
                        pdfBookImages.length > 0 &&
                        pdfBookImages.map((base64String, index) => (
                            <img key={index} src={`data:image/png;base64,${base64String}`} alt={`Book page ${index + 1}`} className="w-full h-auto mb-4" />
                        ))
                    )} */}
                </div>
            </div>
        </div>
    );
}

export default BookViewer;
